export const config = {
  // env:process.env.NODE_ENV || "production",
  API_URL_STAGING:
    process.env.REACT_APP_API_URL ||
    "https://staging-api-perisai.baliola.com/api",
};
